import {AxiosError} from "axios";
import {useQuery} from '@tanstack/react-query'
import api from "../../api/api";
import {ConstructorModel} from "../../types/ConstructorModel";
import {isConstructorSize} from "../../types/ConstructorSize";
import Typecheck from "../../../utils/Typecheck";

const sizesEndpoint = '/builder/sizes';

export const useGetConstructorSizes = (modelId: ConstructorModel['id'] | null) => {
    return useQuery(
        [sizesEndpoint, modelId],
        () => api.get(sizesEndpoint, {params: {modelId}}).then((response: unknown) => {

            if (!response || !Typecheck.isArrayOf(response, isConstructorSize)) {
                throw new AxiosError('Sizes Request have wrong response', 'WRONG_RESPONSE_SIZES');
            }

            return response;
        }).catch(err => {
            throw err;
        }),
        {
            enabled: !!modelId,
            select: (response) => response || [],
        },
    );
};
